export default __webpack_public_path__ + "7378b2a794f32942ed2adc09f411c5e3.svg";